module.exports = __webpack_public_path__ + "img/77.8.TSS.0d6925fa.png";